import { PremiumSessionState } from 'types/premiumSession';

/** Legacy PremiumClasses List defaultProps filter default for instructor parity. */
const PREMIUM_SESSION_LIST_DEFAULT_STATUSES = [
  PremiumSessionState.Scheduled,
] as const;

export function isPremiumDashboardDefaultStatuses(statuses: string[]): boolean {
  const normalized = statuses
    .map((status) => String(status).toLowerCase())
    .sort();
  const defaults = [...PREMIUM_SESSION_LIST_DEFAULT_STATUSES].sort();

  return (
    normalized.length === defaults.length &&
    normalized.every((value, index) => value === defaults[index])
  );
}
